import React, { useState } from "react";
import "./ModalRedefinicaoSenha.css";
import { handleFechar, solicitarRedefinicao } from "./functions";

import { Button } from "../../Button";
import { Input } from "../../Input";

import Modal from "react-bootstrap/Modal";

export interface Mensagem {
  mensagem: string,
  mostrar: boolean,
}

const ModalRedefinicaoSenha = ({ mostrar, fecharModal }: any) => {
  const [email, setEmail] = useState<string>("");
  const [mensagem, setMensagem] = useState<Mensagem>({
    mensagem: "",
    mostrar: false,
  });
  const [sucesso, setSucesso] = useState<boolean>(false);

  return (
    <>
      <Modal show={mostrar} onHide={fecharModal} dialogClassName="auth-recovery-modal">
        <form onSubmit={(e) => handleFechar(e, setSucesso, setEmail)}>
          <Modal.Header closeButton>
            <Modal.Title>Recuperar acesso</Modal.Title>
          </Modal.Header>
          {!sucesso ? (
            <>
              <Modal.Body>
                <div className="recovery-modal-body">
                  <h6 className="modal_titulo">
                    Enviaremos um link seguro para o e-mail cadastrado.
                  </h6>
                  <Input
                    type="email"
                    className="form-control txtValorAporte"
                    label="E-mail cadastrado"
                    placeholder=" "
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {mensagem.mostrar && (
                    <p className="mensagem_erro">{mensagem.mensagem}</p>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div style={{ flex: 1 }}>
                  <Button
                    classNameButton="auth-primary-button btnEnviarEmail"
                    onClick={() => solicitarRedefinicao(setSucesso, email, setMensagem, mensagem)}
                    titleButton="Enviar e-mail"
                  />
                </div>
              </Modal.Footer>
            </>
          ) : (
            <>
              <Modal.Body>
                <div className="recovery-modal-body">
                  <h6 className="modal_titulo">
                    As instruções para criar uma nova senha foram enviadas.
                  </h6>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div style={{ flex: 1 }}>
                  <Button
                    classNameButton="auth-primary-button btnEnviarEmail"
                    onClick={(e) => handleFechar(e, setSucesso, setEmail)}
                    titleButton="Concluir"
                    type="submit"
                  />
                </div>
              </Modal.Footer>
            </>
          )}
        </form>
      </Modal>
    </>
  );
};

export default ModalRedefinicaoSenha;
